import Select from "react-select";
import PropTypes from 'prop-types';

const CustomSelect = ({ 
  options,
  placeholder,
  name,
  onChange,
  value,
  className,
  isDisabled,
  isLoading,
  error,
  isClearable = true,
  isSearchable = true,
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "1px solid #ddd",
      boxShadow: state.isFocused ? "0 0 0 1px var(--background-primary)" : "none",
      fontSize: "var(--font-size-2xs)",
      height: "32px",
      minHeight: "32px",
      backgroundColor: state.isDisabled ? "#f5f5f5" : "var(--background-secondary)",
      "&:hover": {
        border: "1px solid var(--text-primary)"
      }
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0px 8px",
      height: "32px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "32px",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
      padding: "0px",
      color: "#333",
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: "var(--font-size-2xs)",
      zIndex: 9999,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: error ? "#ff0000" : "#757575",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "var(--button-hover)" : state.isFocused ? "var(--button-hover-light)" : "var(--background-light)",
      color: state.isSelected ? "white" : "#333",
      "&:active": {
        backgroundColor: "var(--button-hover)"
      }
    })
  };

  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };

  const handleMenuOpen = () => {
    // No need to stop propagation here as the menu is rendered in a portal
  };

  return (
    <div className="custom-select-container" onClick={(e) => e.stopPropagation()}>
      <Select
        className={className}
        name={name}
        options={options}
        placeholder={placeholder || "Select an option"}
        isClearable={isClearable}
        isSearchable={isSearchable}
        isDisabled={isDisabled}
        isLoading={isLoading}
        styles={customStyles}
        value={options.find((opt) => opt.value === value) || null}
        onChange={handleChange}
        onMenuOpen={handleMenuOpen}
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

CustomSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
};

CustomSelect.defaultProps = {
  placeholder: "Select an option",
  isClearable: true,
  isSearchable: true,
  isDisabled: false,
  isLoading: false,
};

export default CustomSelect;
